﻿﻿import { IBillingReportItems } from './billing-report-items';

export interface IBillingReport {
    donorCenterInvoiceId: number;
    recipientCenterInvoiceId: number;
    transplantDate: string;
    asaUnits: number;
    asaUnitPrice: number;
    physicianCharges: number;
    anesthesiaCharges: number;
    hospitalCharges: number;
    chainId: number;
    clusterNumber: number;
    positionNumber: number;
    swapNumber: string;
    donorId: number;
    donorAlias: string;
    donorCenterAlias: string;
    donorUnosId: string;
    recipientAlias: string;
    recipientCenterAlias: string;
    isSbs: boolean;
    isGlobal: boolean;
    isMedicaid: boolean;
    isMedicare: boolean;
    dateSubmitted: string;
    dateRecipientCenterSubmitted: string;
    claimType: string;
    status: number;
    items: IBillingReportItems;
}
